// extracted by mini-css-extract-plugin
export default {"container":"Error_container__fdK2L","headerText":"Error_headerText__EtTqm","subheaderText":"Error_subheaderText__cLYoz","form":"Error_form__o0ac4","button":"Error_button__NTSvf"};